export default function DownloadCTASection() {
  return (
    <section id="download" className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20elegant%20abstract%20gradient%20background%20with%20amber%20and%20cream%20tones%2C%20soft%20flowing%20shapes%2C%20minimalist%20tech%20atmosphere%2C%20smooth%20curves%2C%20premium%20modern%20design%2C%20clean%20composition%2C%20gentle%20light%20effects&width=1920&height=800&seq=cta-bg-kuaimao&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/35 to-black/40"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-6">
          准备好开始了吗？
        </h2>
        <p className="text-base md:text-lg text-background-50/80 mb-10 max-w-xl mx-auto leading-relaxed">
          立即下载快猫app，开启你的全新移动体验。免费下载，快速安装，马上开始使用！
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="#"
            className="group px-8 py-4 rounded-full bg-background-50 text-foreground-950 font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-3"
          >
            <i className="ri-android-line text-xl"></i>
            <div className="text-left">
              <div className="text-xs opacity-60">Android 版下载</div>
              <div className="text-sm">适用于 Android 8.0+</div>
            </div>
          </a>
          <a
            href="#"
            className="group px-8 py-4 rounded-full bg-background-50 text-foreground-950 font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-3"
          >
            <i className="ri-apple-line text-xl"></i>
            <div className="text-left">
              <div className="text-xs opacity-60">iOS 版下载</div>
              <div className="text-sm">适用于 iOS 14.0+</div>
            </div>
          </a>
        </div>

        <div className="flex items-center justify-center gap-2 text-background-50/60 text-sm">
          <i className="ri-shield-check-line"></i>
          <span>安全下载 · 无毒无插件 · 隐私保护</span>
        </div>
      </div>
    </section>
  );
}